<template>
  <div class="flex_column_evenly pair">
    <div class="flex_row_center">
      <i class="incfont el-icon-title"></i>
      <span lang="OLED" class="margin_left">OLED</span>
    </div>

    <div class="flex_row_center">
      <span lang="Width" class="margin_left">宽</span>
      <el-input-number
      v-model="width"
      @change="handleWidthChange"
      :min="0"
      :max="256"
      size="mini">
      </el-input-number>  

      <span lang="Hight" class="margin_left">高</span>
      <el-input-number
      v-model="hight"
      @change="handleHightChange"
      :min="0"
      :max="256"
      size="mini">
      </el-input-number>        
    </div>

    <div class="flex_row_center">
      <el-button @click="handleBlackClick" class="pair_button"><span lang="OLEDBlack">全黑</span></el-button>
      <el-button @click="handleWhiteClick" class="pair_button"><span lang="OLEDWhite">全白</span></el-button>
      <el-button @click="handleBlackWhiteClick" class="pair_button"><span lang="OLEDBlack">黑白</span></el-button>
      <el-button @click="handleSpotClick" class="pair_button"><span lang="OLEDWhite">斑点</span></el-button>  
      <el-button @click="handleRestoreClick" class="pair_button"><span lang="OLEDWhite">恢复默认</span></el-button>    
    </div>

    <pair-dialog ref="pairDialog"></pair-dialog>
  </div> 
</template>

<script>
import HIDHandle from '@/assets/js/HIDHandle';

  export default {
    data() {
      return {
        width:128,
        hight:80,
        count:1280
      }
    },
    methods: {
      handleWidthChange() {
        this.count = this.width * this.hight / 8;
      },
      handleHightChange() {
        this.count = this.width * this.hight / 8;
      },
      async handleBlackClick() {
        var pixel = new Uint8Array(this.count);
        for(var i = 0;i < this.count;i++) {
          pixel[i] = 0x00;
        }
        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleWhiteClick() {
        var pixel = new Uint8Array(this.count);
        for(var i = 0;i < this.count;i++) {
          pixel[i] = 0xff;
        }
        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleBlackWhiteClick() {
        var pixel = new Uint8Array(this.count);
        for(var j = 0;j < this.hight;j++) {
          for(var i = 0;i < (this.width / 8);i++) {
            pixel[i] = ((j % 2 == 0 ? 0xff : 0x00));
          }
        }

        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleSpotClick() {
        var pixel = new Uint8Array(this.count);
        for(var i = 0;i < this.count;i++) {
          pixel[i] = 0x55;
        }
        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleRestoreClick() {
        await HIDHandle.Restore_Device_OLEDPicture();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>